module.exports = __webpack_public_path__ + "img/black-frame-middle.196cc2dc.png";